var search4i = function(){
	var searchAutoComplete,
	watermarkText = 'Search',
	lightText = '#616161',
	typeText = '#2c2c2c',
	panel = document.getElementById("SuggestionPanel"),
	searchTxtBox = document.getElementById("txtSearch"),
	searchStatus = document.getElementById("searchStatus"),
	searchButton = document.getElementById("submitSearch"),
	keys = {
		ESC: 27,
		TAB: 9,
		RETURN: 13,
		UP: 38,
		DOWN: 40,
		RIGHT: 39,
		LEFT: 37,
		BACK: 8,
		SPACE: 32
	},
	autoCompleteOptions = {
		selector: searchTxtBox,
		appendTo: document.getElementById("autoCompWrapper"), // custom
		minChars: 2,
		source: function(searched, suggest){
			searched = searched.toLowerCase();
			try { autoCompleteRequest.abort(); } catch(e){}
			var autoCompleteRequest = ajax({
				method: "POST",
				url: '/Header/SearchAutoComplete',
				timeout: 15000,
				data: { searchTerm: searched },
				async: true
			});
			autoCompleteRequest.then(function(response, xhr){
				// response includes array of objects with SearchTerm and ResultCount values
                		if (response.length === 0 || searchTxtBox.value === "" || searchTxtBox.value === watermarkText){
					searchStatus.innerHTML = 'No autocomplete results available';
				} else{ 
					searchStatus.innerHTML = response.length + ' Autocomplete results are available for '+ searchTxtBox.value + ', use up and down arrow keys to navigate.'; 
				}
				suggest(response); 
			});
		},
		onSelect: function(e, term, item){
			e.preventDefault();
			term.value = item;
            		search(item);
		},
		renderItem: function (item, search){
			search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'); // term searched for in input field
			var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
			return '<li class="autocomplete-suggestion pointer" role="option" aria-selected="false" aria-haspopup="true" data-val="' + item.SearchTerm + '"><span class="searchAutoLeft floatLeft">' + item.SearchTerm.replace(re, '<span class="bold">$1</span>') + '</span><span class="floatRight">' + item.ResultCount + ' results</span></li>';
		},
		termSelected: function(e, term, item){ // custom
			showSuggestionPanel(term);
		},
		onClose: function(){ // custom
			//hideSuggestionPanel();
		}
	},
	initAutoComplete = function(){
		searchAutoComplete = new autoComplete(autoCompleteOptions);
	},
	destroyAutoComplete = function(){
		searchAutoComplete.destroy();
	}
	showSuggestionPanel = function(searchTerm){
		var searchSuggestRequest = ajax({
			method: "POST",
			url: '/Header/SearchBoxSuggestions',
			timeout: 20000,
			data: { searchTerm: searchTerm }
		});
	    	searchSuggestRequest.then(function(response, xhr){
			// set left position to be to the right of autocomplete list
			var leftPosition = document.getElementById("txtSearch").offsetWidth + 7;
			panel.style.left = leftPosition + "px";
			panel.innerHTML = response;
			panel.classList.remove("hide");
			panel.style.display = "block";
			panel.setAttribute("aria-hidden", "false");
			panel.addEventListener("keydown", function(e){
				if(document.getElementById("SearchSuggestionPanelViewAll") == document.activeElement){
					switch (e.keyCode) {
						case keys.TAB:
							panel.getElementsByTagName("a")[0].focus();
					}
				}
				if(panel.getElementsByTagName("a")[0] == document.activeElement){
					switch (e.keyCode) {
						case keys.LEFT:
							hideSuggestionPanel();
							searchTxtBox.focus();
					}
				}
			});
		});
		searchTxtBox.addEventListener("keyup", function(e){
			if(e.keyCode == keys.RIGHT){
				panel.getElementsByTagName("a")[0].focus();
			}
		});
	},	
	hideSuggestionPanel = function(e){
		panel.classList.add("hide");
		panel.setAttribute("aria-hidden", "true");
		panel.style.display = "none";
	},
	search = function(el) {
		var searchText;
		if (el.id == "submitSearch") {
			searchText = searchTxtBox.value;
		}else {
			searchText = el.getAttribute("data-val");
		}
		var searchRequest = ajax({
			method: "POST",
			url: '/Header/Search',
			timeout: 15000,
			data: { searchText: searchText }
		});
		searchRequest.then(function(response, xhr){
			window.location.href = response.url;
		});
	},	
	addSearchEvents = function(){
		searchButton.addEventListener("click", function(e){
			e.preventDefault();
			search(searchButton);
		}); 
		searchTxtBox.addEventListener('focus', function(e){
			initAutoComplete(); // don't initialize on page load due to accessibility issues
			if (e.target.value == watermarkText) {
				e.target.value = "";
				e.target.style.color = typeText;
			}
		});
		searchTxtBox.addEventListener('blur', function(e){
			destroyAutoComplete();
			if (e.target.value == "") {
				e.target.value = watermarkText;
				e.target.style.color = lightText;
			}
		});	
		searchTxtBox.addEventListener('keyup', function(e){
			if(e.keyCode == keys.RETURN) {
				search(searchButton);
			}
		});
		document.addEventListener('click', function(e){
			if(panel.style.display === "block"){
				if(e.target.closest('#SuggestionPanel') || e.target.closest("#autoCompWrapper")){
					hideSuggestionPanel();
				}
			}
		}, false);
	},	
	init = function(){
		searchTxtBox.style.color = lightText;
		searchTxtBox.value = watermarkText;
		addSearchEvents();
	};
	
	return{
		init: init
	};
};